import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { X, Send } from "lucide-react";

export default function TelegramJoinPopup() {
  const [dismissed, setDismissed] = useState(false);

  // Check if we dismissed this session or permanently in local storage
  useEffect(() => {
    if (localStorage.getItem("telegram_popup_dismissed") === "true") {
      setDismissed(true);
    }
  }, []);

  const { data, isLoading } = useQuery({
    queryKey: ["telegram-status"],
    queryFn: () => api.get("/telegram/status").then(r => r.data),
    staleTime: 60000,
  });

  if (isLoading || dismissed || !data) return null;

  // show_popup means: popup is enabled in admin AND user hasn't linked telegram bot yet
  if (!data.show_popup || !data.invite_link) return null;

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem("telegram_popup_dismissed", "true");
  };

  const handleJoin = () => {
    window.open(data.invite_link, "_blank");
    handleDismiss(); // don't ask again if they clicked join
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="bg-ink-900 border border-amber-500/30 rounded-xl p-6 max-w-md w-full shadow-2xl relative animate-in fade-in zoom-in duration-200">
        <button 
          onClick={handleDismiss}
          className="absolute top-4 right-4 text-white/50 hover:text-white transition-colors"
        >
          <X className="size-5" />
        </button>
        
        <div className="flex flex-col items-center text-center mt-2">
          <div className="bg-blue-500/20 p-4 rounded-full mb-4">
            <Send className="size-8 text-blue-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Join our Telegram</h2>
          <p className="text-white/70 mb-6">
            Stay updated with the latest AI signals, market news, and premium trading setups directly in our Telegram channel.
          </p>
          
          <div className="flex w-full gap-3">
            <button 
              onClick={handleDismiss}
              className="flex-1 py-2.5 rounded-lg border border-white/10 hover:bg-white/5 font-semibold transition-colors"
            >
              Later
            </button>
            <button 
              onClick={handleJoin}
              className="flex-1 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-500 font-semibold text-white transition-colors flex items-center justify-center gap-2"
            >
              <Send className="size-4" />
              Join Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}